import React, { useCallback, useEffect, useMemo, useState, } from "react";
import { Card, Col, Container, Row, Pagination } from "react-bootstrap";

import Loader from "react-loader-spinner";
import { useLocation, useSearchParams } from "react-router-dom";

import { BaseUrl } from "../../common/FormatHelper";

import PracticeFacets from "../../components/Practices/PracticeFacets/PracticeFacets";
import PracticeResults from "../../components/Practices/PracticeResults/PracticeResults";

import styles from "./PracticeSearch.module.css";

import axios from "axios";
// import * as AxiosLogger from 'axios-logger';

const api = axios.create({
	baseURL: BaseUrl(),
});
// api.interceptors.request.use((request) => {
// 	return AxiosLogger.requestLogger(request, {
// 		params: true,
// 	});
// });
// api.interceptors.response.use(AxiosLogger.responseLogger);

const PracticeSearch = (props) => {
	const location = useLocation();
	const [searchParams, setSearchParams] = useSearchParams();

	const queryParams = useMemo(() => {
		return new URLSearchParams(location.search);
	}, [location]);
	
	const [facets, setFacets] = useState([]);
	const [pagination, setPagination] = useState([]);
	const [practices, setPractices] = useState([]);
	const [practiceCount, setPracticeCount] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);

	const onToggleChanged = useCallback(async (name, value) => {
		if(value === false) {
			queryParams.delete(name);
			setSearchParams(queryParams);
			return;
		}

		queryParams.set(name, value);
		setSearchParams(queryParams);
	}, [setSearchParams, queryParams]);

	const onFacetChanged = useCallback(async (name, value) => {
		if(value === null) {
			queryParams.delete(name);
			setSearchParams(queryParams);
			return;
		}

		const facetValues = value.map((v) => v.value);
		queryParams.set(name, facetValues);
		setSearchParams(queryParams);
	}, [setSearchParams, queryParams]);
	
	const onPageChanged  = useCallback(async (event) => {
		queryParams.set('page', event.target.text);
		setSearchParams(queryParams);
	}, [setSearchParams, queryParams]);

	const searchPractices = useCallback(async () => {
		setIsLoading(true);
		setError(null);

		const apiParams = { params: {} };
		searchParams.forEach((value, key) => {
			// apiParams[key] = value.split(',');
			apiParams['params'][key] = value;
		});

		try {
			const facets_response = await api.get('/v3/practices/facets', apiParams);
			const search_response = await api.get('/v3/practices/search', apiParams);

			const facets = facets_response.data.response.facets;
			setFacets(facets);

			const response = search_response.data.response;
			setPracticeCount(response.counts.total);
			setPractices(response.results);

			if(response.pagination !== undefined) {
				setPagination(response.pagination);
			}
		} catch (ex) {
			setError(ex.message);
		} finally {
			setIsLoading(false);
		}
	}, [searchParams]);

	useEffect(() => {
		searchPractices();
	}, [searchPractices]);
	
	let content = <Loader type="Oval" color="#00BFFF" height={100} width={100} timeout={10000} className="loader" />;
	let paginationContent = null;

	if(!isLoading) {
		let paginationItems = [];
		for(let page = pagination.start; page < pagination.end; page++) {
			paginationItems.push(
				<Pagination.Item key={page} active={page === pagination.current} onClick={onPageChanged}>
					{page}
				</Pagination.Item>
			);
		}
		
		paginationContent = (
			<Pagination size="lg" className="justify-content-md-center">
				<Pagination.First onClick={onPageChanged} />
      			<Pagination.Prev onClick={onPageChanged} />
				{paginationItems}
				<Pagination.Next onClick={onPageChanged} />
				<Pagination.Last onClick={onPageChanged} />
			</Pagination>
		);

		if(error) {
			content = <Card><Card.Body>{error}</Card.Body></Card>;
		} else if(practices.length === 0) {
			content = <Card><Card.Body>No practices found!</Card.Body></Card>;
		} else if(practices.length > 0) {
			content = (
				<React.Fragment>
					<div className={styles.practiceCount}>{practiceCount} practices found!</div>
					<PracticeResults practices={practices} />
				</React.Fragment>
			);
		}
	}

	return (
		<Container className={styles.bodyContainer}>
			<Row>
				<Col lg={3}>
					<PracticeFacets facets={facets} onFacetChanged={onFacetChanged} onToggleChanged={onToggleChanged} />
				</Col>
				<Col lg={9}>
					{content}
					{paginationContent}
				</Col>
			</Row>
		</Container>
	)
}

export default PracticeSearch;